import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Button, IconButton, Snackbar } from '@tino-frontend/coreui'
import { CloseIcon } from '@tino-frontend/icons'
import { useTexts } from './page.texts'
import { useSW, withUserTarget } from 'wrappers'
import { useWebView } from 'modules/web-view'
import { WebViewPostMessageType } from '@types'
import { REACT_APP_ENV } from 'constants/envs'

type BootstrapProps = {
  location: Location
}

const Bootstrap = (props: BootstrapProps) => {
  const { location } = props
  const texts = useTexts()
  const { updateAvailable } = useSW()
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()
  const { listen } = useHistory()
  const { sendMessage } = useWebView()

  function handleClose() {
    setOpen(false)
  }

  function reload() {
    //@ts-ignore
    location.reload(true)
  }

  useEffect(() => {
    window.addEventListener('error', (event) => {
      if (REACT_APP_ENV !== 'prd') return

      // This is necessary by PWA
      if (
        event.message.indexOf('Failed to fetch dynamically imported module')
      ) {
        reload()
      }
    })

    sendMessage({ type: WebViewPostMessageType.NAVIGATE, data: { pathname } })
  }, [pathname])

  useEffect(() => {
    setOpen(updateAvailable)
    if (updateAvailable) {
      window.forceReload = true
    }
  }, [updateAvailable])

  useEffect(() => {
    listen((_loc, action) => {
      if (action === 'PUSH' && window.forceReload) {
        window.forceReload = false
        // @ts-ignore
        location.reload(true)
      }
    })
    sendMessage({ type: WebViewPostMessageType.APP_MOUNTED, data: {} })
  }, [])

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={6000}
      message={texts.serviceWorker.message}
      action={
        <>
          <Button
            data-testid="reload"
            color="primary"
            size="small"
            onClick={reload}
          >
            {texts.serviceWorker.action}
          </Button>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
    />
  )
}

const Component = withUserTarget(Bootstrap)

export default Component
